import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import weChatAuth from "../wechat/weChatAuth";
import { Y_TOKEN } from "../utils/Var";

if (!window.VueRouter) {
    Vue.use(VueRouter);
}

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;

    if (to.matched.some(item => item.meta.requiredAuth)) {
        sessionStorage.setItem("callbackURL", to.fullPath);

        const token = localStorage.getItem(Y_TOKEN);
        if (!token) {
            // if (process.env.VUE_APP_RUN_ENV === "prod") {
                return weChatAuth().then(() => {
                    next();
                });
            // }
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
